import * as React from 'react';
import { DefaultButton, ITextStyles, MessageBar, MessageBarType, Panel, PanelType, PrimaryButton } from '@fluentui/react';

import { useEffect, useState } from 'react';
import { IField, IMailbox, ITextField } from '../../../shared/interfaces';
import DynamicForm from '../../DynamicForm/DynamicForm';
import { useBoolean } from '@fluentui/react-hooks';
import AppUtilities from '../../../shared/Utilities/appUtilities';
import CircleLoader from '../../Loader/CircleLoader/CircleLoader';
import { RootState } from '../../../store';
import { connect, ConnectedProps, useSelector } from 'react-redux';
import Utilities from '../../../shared/Utilities/utilities';



const textStyles: Partial<ITextStyles> = {
    root: {
        display: 'block',
        marginTop: '18px'
    }
}

const mapState = (state: RootState) => ({
    currentAoo: state.sessionReducer.currentAoo
})

const mapDispatch = {

}

const connector = connect(mapState, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>

export interface AddEditMailboxesManagerProps {
    loading?: boolean
    extraCssClass?: string
    selectedMailboxManager?: Partial<IMailbox>
    panelHeaderText: string
    panelIsOpen: boolean
    onSubmit: (mailboxManagerItem: Partial<IMailbox>) => void
    onDismiss: () => void
    panelIsEdit: boolean
    mailboxesList: IMailbox[]
}

type Props = AddEditMailboxesManagerProps & PropsFromRedux

const AddEditMailboxesManager: React.FunctionComponent<Props> = (props) => {
    let loading = props.loading !== undefined ? props.loading : false;

    const [panelIsOpen, setPanelIsOpen] = useState<boolean>(props.panelIsOpen);
    const [messageBarIsVisible, { setTrue: showMessageBar, setFalse: dismissMessageBar }] = useBoolean(false);
    const [messageBarType, setMessageBarType] = useState<MessageBarType>();
    const [messageBarText, setMessageBarText] = useState<string>('');
    const [fields, setFields] = useState<IField[]>([]);


    useEffect(() => {

        setFieldsValues();
        dismissMessageBar();
        setPanelIsOpen(props.panelIsOpen);

    }, [props.panelIsOpen]);


    useEffect(() => {
        setFieldsValues();
    }, [props.panelIsEdit, props.selectedMailboxManager, props.panelIsOpen]);


    const setFieldsValues = () => {
        let addressValue;
        let enabledValue;
        let aooValue;

        //Quando seleziono una cassetta, vuol dire che sto in modifica e tiro su i dati
        if (props.selectedMailboxManager) {
            let mailboxSelezionata = props.selectedMailboxManager;

            // Per il campo address
            addressValue = mailboxSelezionata.address;

            // per attivo/disattivo
            enabledValue = mailboxSelezionata.enabled;

            aooValue = props.currentAoo;

        }

        let newFields = [
            {
                displayName: "Indirizzo di posta",
                internalName: "email",
                sharepointType: "Text",
                controlType: "textbox",
                required: true,
                readonly: false,
                disabled: false,
                system: false,
                internalValue: addressValue ? addressValue : "",
                touched: false,
                pattern: Utilities.GetRegexEmailSingola(),
            } as ITextField,
            {
                displayName: "Attiva la cassetta",
                internalName: "enabled mailbox",
                sharepointType: "Yes/No",
                controlType: "boolean",
                required: true,
                readonly: false,
                disabled: false,
                system: false,
                internalValue: enabledValue,
                touched: false

            } as IField,

        ]
        setFields(newFields);
    }

    //// Click su salva del panel laterale
    const addEditMailboxesManagerPanelSubmit = () => {

        if (checkMailboxManagerFormValidity()) {
            let mailboxItem: Partial<IMailbox> = {
                id: props.selectedMailboxManager?.id,
                address: fields.find(el => el.internalName === 'email')?.internalValue,
                enabled: fields.find(el => el.internalName === 'enabled mailbox')?.internalValue,
                aooId: props.currentAoo!.id
            };

            props.onSubmit(mailboxItem);
            resetFormFields();
        }
    }

    const resetFormFields = () => {

        let newFields = fields.map(el => {
            return { ...el, internalValue: null, touched: false, valid: true };
        });
        setFields(newFields);
    }

    const checkMailboxManagerFormValidity = (): boolean => {

        let isValid = true;

        const updatedFields = fields.map((item, index) => {
            let fieldValidity = AppUtilities.checkFieldValidity(item);
            if (!fieldValidity)
                isValid = false;

            return {
                ...item,
                touched: true,
                valid: fieldValidity
            }
        });
        setFields(updatedFields);
        if (isValid) {
            dismissMessageBar();
        }
        else {
            setMessageBarText('Compilare correttamente i campi');
            setMessageBarType(MessageBarType.error);
            showMessageBar();
        }

        return isValid;
    }


    const inputChangedHandler = (newField: IField) => {

        const updatedFields = [...fields];
        let itemIndex = updatedFields.findIndex(el => el.internalName === newField.internalName);
        updatedFields[itemIndex] = { ...newField };

        setFields(updatedFields);
    }

    const onRenderLateralPanelFooterContent = () => {
        return (
            <React.Fragment>
                <PrimaryButton
                    styles={{ root: { marginRight: 8 } }}
                    text="Salva"
                    onClick={addEditMailboxesManagerPanelSubmit}
                />
                <DefaultButton
                    onClick={props.onDismiss}
                    text="Annulla"
                />
            </React.Fragment>
        );
    }

    return (
        <React.Fragment>
            <Panel
                key='addEditMailboxesManagerPanel'
                isLightDismiss
                isOpen={panelIsOpen}
                type={PanelType.custom}
                customWidth={'600px'}
                headerText={props.panelHeaderText}
                focusTrapZoneProps={{
                    isClickableOutsideFocusTrap: true,
                    forceFocusInsideTrap: true,
                }}
                onDismiss={props.onDismiss}
                onRenderFooterContent={onRenderLateralPanelFooterContent}
                isFooterAtBottom={false}
            >
                {messageBarIsVisible &&
                    <MessageBar
                        messageBarType={messageBarType}
                        isMultiline={false}
                        onDismiss={dismissMessageBar}
                        dismissButtonAriaLabel="Close">{messageBarText}</MessageBar>
                }

                <CircleLoader loaderClass='loader-large' loading={loading} />




                <div className={"flex flex-column position-relative overflow-hidden"}>

                    <div className={`position-relative my-scroll-div`}>

                        <DynamicForm
                            fields={fields}
                            onInputChangedHandler={(newField) => { inputChangedHandler(newField) }}
                        />
                    </div>
                </div>
            </Panel>

        </React.Fragment>

    );
}

export default connector(AddEditMailboxesManager);
